import React, { useCallback, useMemo } from 'react';
import { costFormater } from '@common-fe/common-fe';

import { useCategorySpendLimitsStore } from '../SpendLimitsModal/stores';

interface Props {
  category: string;
  id: string;
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isPlanActive?: boolean;
  isEditableTemplate?: boolean;
  isPerCategorySpendLimit?: boolean;
  isChecked: boolean;
  isIndeterminate?: boolean;
  onSelect: (id: string) => void;
}

export const useCategoryItemActions = ({
  category,
  id,
  isEditMode,
  isTemplateMode,
  isPlanActive,
  isEditableTemplate,
  isPerCategorySpendLimit,
  isChecked,
  isIndeterminate,
  onSelect,
}: Props) => {
  const spendLimit = useCategorySpendLimitsStore(
    useCallback((state) => state.spendLimits.find((item) => item.category_type === category), [category])
  );

  const isDisabled = useMemo(() => {
    return !isEditMode || (isTemplateMode && isPlanActive && !isEditableTemplate);
  }, [isEditMode, isTemplateMode, isPlanActive, isEditableTemplate]);

  const spendLimitDisplay = useMemo(() => {
    if (!isPerCategorySpendLimit) return null;

    const isEligible = isChecked || isIndeterminate;

    if (spendLimit?.category_spend_limit) {
      return costFormater(parseFloat(spendLimit.category_spend_limit), true);
    }
    if (isEligible) {
      return 'Unlimited';
    }
    return '-';
  }, [isPerCategorySpendLimit, spendLimit, isChecked, isIndeterminate]);

  const handleCheckBoxClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  const handleChange = useCallback(() => {
    if (!isDisabled) {
      onSelect(id);
    }
  }, [isDisabled, onSelect, id]);

  return {
    isDisabled,
    spendLimitDisplay,
    handleCheckBoxClick,
    handleChange,
  };
};
